<template>
  <div v-bind:style="{ height: height + 'px' }">
    <div class="content_header">
      <v-toolbar flat color="white mx-2" width="100%">
        <v-toolbar-title style="mar" width="40%">
          <v-row class="pr-3" align-content="center" height="100%">
            <v-col>
              <img
                src="https://appmedia.jp/wp-content/uploads/2018/03/9d963c14bb521f1b7661952369b5a883.png"
                width="40px"
              />おすすめスマホアプリ管理 v1.12
            </v-col>
          </v-row>
        </v-toolbar-title>
      </v-toolbar>
    </div>

    <!-- <v-checkbox v-model="pr_edit_mode" label="PR(広告)"></v-checkbox
    > -->

    <v-card class="ma-4 pa-2 text-right">
      <table style="width:100%;">
        <tr>
          <td width="220" style="text-align:left;">
            <a
              class="pl-6"
              href="https://admin.appmedia.jp/app_rank"
              target="_blank"
              >本番確認用ページ</a
            >
          </td>
          <td width="340">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              id="data_search"
              class="mx-2 pa-4"
              placeholder="アプリ名やカテゴリで検索"
            ></v-text-field>
          </td>
          <td>
            <a class="pl-6 mr-10" href="/manage/#/recommendAppli/all">総合</a>
            <a class="pl-6 mr-10" href="/manage/#/recommendAppli/sort"
              >カテゴリ並び替え</a
            >
            <a class="pl-6 mr-10" href="/manage/#/recommendAppli/genre"
              >ジャンル</a
            >
            <a class="pl-6 mr-10" href="/manage/#/recommendAppli/tag">タグ</a>

            <a class="pl-6 mr-10" href="/manage/#/recommendAppli/pr">PR一括設定</a>


            <v-btn color="primary" dark class="mb-2" @click="editItem()"
              >新規追加</v-btn
            >
            <v-btn
              color="red darken-4"
              dark
              class="mb-2"
              @click="filePut()"
              style="margin-left:20px;"
              >本番データ反映</v-btn
            >
          </td>
        </tr>
      </table>
    </v-card>
    <v-card class="ma-4">
      <v-radio-group v-model="search" row class="pl-4 pt-4">
        <v-radio
          v-for="(item, index) in category"
          :key="index"
          :label="item"
          :value="item"
        ></v-radio>

        <v-radio value="非表示" label="非表示"></v-radio>
      </v-radio-group>

      <v-data-table
        :headers="headers"
        :items="list"
        :search="search"
        :custom-filter="customFilter"
        :items-per-page="50"
        :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
      >
        <template v-slot:item.edit="{ item }">
          <v-icon
            small
            color="primary"
            @click="editItem(item)"
            >fas fa-edit</v-icon
          >
        </template>

        <template v-slot:item.id="{ item }">
          <span v-if="item.store_id != 0 && item.store_id != ''">{{
            item.id
          }}</span>
          <span v-else style="color:red;">{{ item.id }}</span>
        </template>

        <template v-slot:item.rank="{ item }">
          <div
            @click="editItem(item)"
            text
            v-if="item.rank != '' || item.disp_flg == 0"
          >
            {{ item.rank }}
          </div>
          <div @click="editItem(item)" text v-else>非表示</div>
        </template>

        <template v-slot:item.pr="{ item }">
          <span v-if="item.pr == 1" class="pr">PR</span>
        </template>

        <template v-slot:item.content="{ item }">
          <div @click="editItem(item)" text>
            <div @click="editItem(item)" text class="pa-1">
              <img
                :src="item.icon"
                width="56px"
                style="vertical-align: middle;"
                v-if="item.icon"
              />
            </div>
          </div>
        </template>

        <template v-slot:item.title="{ item }">
          <div v-if="item.url == ''">
            <div class="yellow" @click="editItem(item)" text>
              {{ item.title }}
            </div>
          </div>
          <div v-else>
            <div @click="editItem(item)" text>{{ item.title }}</div>
          </div>
        </template>

        <template v-slot:item.hyouka="{ item }">
          <div><span style="color:#ffd11c">★</span>{{ item.hyouka }}</div>
        </template>

        <template v-slot:item.description1="{ item }">
          <div @click="editItem(item)" text>{{ item.description1 }}</div>
        </template>

        <template v-slot:item.delete="{ item }">
          <v-icon
            v-if="item.disp_flg == 1"
            small
            color="gray accent-4"
            @click="enableItem(item)"
            class="pr-4"
            >fas fa-eye-slash</v-icon
          >
          <v-icon
            v-if="item.disp_flg == 0"
            small
            color="gray accent-4"
            @click="disableItem(item)"
            class="pr-4"
            >fas fa-eye</v-icon
          >

          <v-icon
            small
            color="red accent-4"
            @click="deleteItem(item)"
            class="pr-4"
            >fas fa-trash</v-icon
          >
        </template>
      </v-data-table>
    </v-card>

    <!-- プレビュー -->
    <v-dialog v-model="showDialogPreview" width="1000">
      <v-card style="margin: 10px auto;" class="all_preview">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showDialogPreview = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>全体プレビュー</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-row style="width:1000px;margin:0 auto;">
          <v-col cols="6" style="">
            <h3>詳細</h3>
            <div
              data-v-f3f3eg9
              id="preview"
              v-html="videoplay(target_description2)"
              style="border: 1px solid #ccc;padding:0 10px;min-height:100px;"
            ></div>
          </v-col>
          <v-col cols="6">
            <h3>一覧</h3>
            <div
              data-v-f3f3eg9
              id="preview"
              v-html="videoplay(target_description3)"
              style="border: 1px solid #ccc;padding:0 10px;min-height:100px;"
            ></div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <!-- 編集画面 -->
    <v-row justify="center">
      <v-dialog v-model="showDialog" scrollable persistent max-width="1500px">
        <v-card width="800" :disabled="loading">
          <v-overlay :absolute="true" :value="loading">
            <v-progress-circular
              :size="70"
              :width="7"
              color="yellow"
              indeterminate
            ></v-progress-circular>
          </v-overlay>

          <v-card-title class="pa-0" style="border-bottom: 1px solid #ddd;">
            <v-row class="ml-1 pb-0" style="width:100%" align-content="center">
              <v-col cols="2" class="pb-0 pt-6" align="center"
                >アプリ更新</v-col
              >

              <v-col cols="1"> <v-divider vertical></v-divider></v-col>
              <v-col cols="7">
                <v-tabs center-active v-model="tab" class="pl-4">
                  <v-tab>基本情報</v-tab>
                  <v-tab>あらすじ</v-tab>
                  <v-tab>おすすめポイント</v-tab>
                  <v-tab>ユーザの声</v-tab>
                  <v-tab>フッター</v-tab>
                </v-tabs></v-col
              >

              <v-col cols="2" class="text-right">
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDialog()"
                  style="font-size:40px;"
                  >×</v-btn
                >
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text style="width:100%; background:#fff;padding:0 10px;">
            <div style="background-color:#fff;padding: 0 16px;">
              <v-tabs-items v-model="tab" class="">
                <v-tab-item>
                  <v-row class="pa-1 ml-1" style="width:100%" align="center">
                    <v-col class="pa-2" cols="2" align="center">
                      <v-checkbox
                        v-model="target_pr"
                        true-value="1"
                        false-value="0"
                        label="PR(広告)"
                      ></v-checkbox>

                      <div class="img_preview">
                        <img
                          v-if="target_icon"
                          :src="target_icon"
                          width="100px"
                          height="100px"
                        />
                      </div>

                      <v-form ref="form">
                        <v-file-input
                          v-model="input_image"
                          accept="image/*"
                          label="アプリアイコンアップロード"
                          prepend-icon="mdi-image"
                          @change="onImagePicked"
                          multiple
                          dense
                        ></v-file-input>
                      </v-form>
                    </v-col>
                    <v-col cols="10" style="veatical">
                      <div class="mb-4">
                        <v-text-field
                          label="ストアID(ios)"
                          hide-details="auto"
                          v-model="target_store_id"
                        ></v-text-field>
                      </div>
                      <div class="mb-4">
                        <v-text-field
                          label="ゲームタイトル"
                          hide-details="auto"
                          :rules="rules"
                          v-model="target_title"
                        ></v-text-field>
                      </div>

                      <v-row class="mb-4">
                        <v-col cols="8">
                          <v-text-field
                            label="記事URL"
                            hide-details="auto"
                            v-model="target_url"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <a
                            :href="target_url"
                            class="pl-2 pt-4"
                            target="_blank"
                            style="display: block;"
                            >▶︎ページ確認</a
                          ></v-col
                        >
                      </v-row>

                      <div class="mb-4">
                        <v-text-field
                          label="見出し(アイコン横の見出し)"
                          hide-details="auto"
                          v-model="target_description1"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row class="pa-1 ml-1" style="width:100%">
                    <v-col>
                      <v-text-field
                        label="順位(半角数字)"
                        hide-details="auto"
                        class="pa-0"
                        :rules="rules"
                        v-model="target_rank"
                        maxlength="3"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="評価点(1~5)"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_hyouka"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-select
                        label="アプリカテゴリ(新作、人気等)"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_category"
                        :items="category"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-row class="pa-1 ml-1" style="width:100%">
                    <v-col>
                      <v-select
                        label="ジャンル"
                        class="pa-0"
                        :items="genres"
                        multiple
                        v-model="target_genre"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="タグ(カンマ区切り)"
                        class="pa-0"
                        :items="tags"
                        multiple
                        v-model="target_tag"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="pa-1 ml-1" style="width:100%">
                    <v-col>
                      <v-text-field
                        style
                        label="対応機種"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_os"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="DL容量"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_dl_vol"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="配信日"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_date"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="pa-1 ml-1">
                    <v-col cols="10">
                      <v-text-field
                        label="パブリッシャー"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_publisher"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>

                <!-- あらすじ -->

                <v-tab-item style="height:auto;">
                  <v-row
                    class="pl-3 pr-3 pt-2"
                    style="position: sticky;top:0;z-index: 9999;background:#fff;"
                  >
                    <v-col cols="5">
                      <v-file-input
                        v-model="input_image2"
                        counter
                        label="画像追加"
                        accept="image/*, video/*"
                        show-size
                        prepend-icon="mdi-file-image-plus"
                        outlined
                        multiple
                        @change="onImagePicked2"
                        ref="img_file"
                      ></v-file-input>

                      <v-row style="padding-right: 10px;" dense>
                        <v-col
                          style="text-align:center;line-height: 2.5;position:sticky;top: 0;"
                          class="menu_icon"
                        >
                          <span
                            style=" border: 1px solid #222; border-radius: 5px; margin-right:5px; padding:5px; background-color: #fff;"
                            @click="pDecoration(item)"
                          >
                            <span>p</span>
                          </span>

                          <span
                            style=" border: 1px solid #222; border-radius: 5px; margin-right:5px; padding:5px; background-color: #fff;"
                            @click="linkDecoration(item)"
                          >
                            <span>a</span>リンク
                          </span>

                          <span
                            style=" border: 1px solid #222; border-radius: 5px; margin-right:5px; padding:5px; background-color: #fff;"
                            @click="titleDecoration(item)"
                          >
                            <v-icon style="font-size:20px;font-size: 20px;"
                              >mdi-format-title</v-icon
                            >見出し
                          </span>
                          <span
                            style=" border: 1px solid #222; border-radius: 5px; margin-right:5px; padding:5px; background-color: #fff;"
                            @click="boldDecoration(item)"
                          >
                            <v-icon color="red accent-4" style="font-size:20px;"
                              >mdi-format-bold</v-icon
                            >赤太字
                          </span>
                          <span
                            style=" border: 1px solid #222; border-radius: 5px; margin-right:5px; padding:5px; background-color: #fff;"
                            @click="underDecoration(item)"
                          >
                            <v-icon
                              color="yellow darken-2"
                              style="font-size:20px;"
                              >mdi-format-underline</v-icon
                            >マーカー
                          </span>
                          <span
                            style=" border: 1px solid #222; border-radius: 5px; padding:5px; background-color: #fff;"
                            @click="tableDecoration(item)"
                          >
                            <v-icon style="font-size:20px;"
                              >mdi-table-settings</v-icon
                            >テーブル
                          </span>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="8">
                          <v-tabs
                            v-model="outline_tab"
                            color="deep-purple"
                            fixed-tabs
                            bg-color="indigo-darken-2"
                            class="mt-0 bold"
                          >
                            <v-tab :value="0">詳細用</v-tab>
                            <v-tab :value="1">一覧用</v-tab>
                          </v-tabs>
                        </v-col>
                        <v-col>
                          <v-btn
                            outlined
                            style="border:none;"
                            @click="showDialogPreview = !showDialogPreview"
                            class="mt-1"
                          >
                            <span
                              style="color: #1976d2;border-bottom: 1px solid #2196f3;"
                              >全体プレビュー</span
                            ></v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col
                      style="border:1px dashed #666; border-radius:5px;"
                      cols="7"
                    >
                      <ul
                        style="list-style-type:none; position:relative; width:100%; overflow-y:scroll; height:100%;padding:0px;max-height: 200px;"
                      >
                        <li
                          v-for="item in img_items"
                          :key="item.id"
                          style="float:left;"
                        >
                          <div v-if="item.alt.indexOf(target_title) > -1">
                            <div v-if="item.img_path.indexOf('.mp4') > -1">
                              <video
                                style="object-fit: cover; width: 80px; height: 80px;padding-left:8px;"
                                @click="insertImg(item)"
                                :src="item.img_path"
                                width="100px"
                                autoplay
                                muted
                                loop
                              ></video>
                            </div>
                            <div v-else>
                              <img
                                style="object-fit: cover; width: 80px; height: 80px;padding-left:8px;"
                                @click="insertImg(item)"
                                :src="item.img_path"
                                width="100px"
                              />
                            </div>
                          </div>
                        </li>
                      </ul>
                    </v-col>
                  </v-row>

                  <div v-show="outline_tab == 0">
                    <v-row class="pa-1 ml-1" style="width:100%;">
                      <v-col>
                        <v-textarea
                          rows="30"
                          height="420"
                          class="custom_textarea pt-1"
                          outlined
                          no-resize
                          v-model="target_description2"
                          label="詳細ページ(本文"
                          counter="3000"
                          ref="textarea1"
                          id="1"
                          @blur="onBlur"
                        ></v-textarea>
                      </v-col>

                      <v-col cols="3">
                        <span style="font-size:10px;">簡易プレビュー</span>
                        <div
                          data-v-f3f3eg9
                          id="preview"
                          v-html="target_description2"
                          style="border: 1px solid rgb(170, 170, 170);padding: 0 10px;overflow: scroll;"
                        ></div>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-show="outline_tab == 1">
                    <v-row class="pa-1 ml-1" style="width:100%">
                      <v-col>
                        <v-textarea
                          label="一覧用のあらすじ"
                          hide-details="auto"
                          outlined
                          no-resize
                          class="pa-0"
                          ref="textarea5"
                          id="5"
                          rows="30"
                          counter="3000"
                          height="420"
                          @blur="onBlur"
                          v-model="target_description3"
                        ></v-textarea>
                      </v-col>

                      <v-col cols="3">
                        <span style="font-size:10px;">簡易プレビュー</span>
                        <div
                          data-v-f3f3eg9
                          id="preview"
                          v-html="target_description3"
                          style="border: 1px solid rgb(170, 170, 170);padding:0 10px;overflow: scroll;min-height:100px;"
                        ></div>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>
                <v-tab-item>
                  <v-card-title>おすすめポイント</v-card-title>

                  <div style="border-radius: 20px;">
                    <v-row style="padding-right: 10px;">
                      <v-col
                        style="text-align:center;line-height: 2.5; text-align: left; margin-left: 40px;"
                      >
                        <span
                          style=" border: 1px solid #222; border-radius: 5px; margin-right:5px; padding:5px; background-color: #fff;"
                          @click="boldDecoration(item)"
                        >
                          <v-icon color="red accent-4" style="font-size:20px;"
                            >mdi-format-bold</v-icon
                          >赤太字
                        </span>
                        <span
                          style=" border: 1px solid #222; border-radius: 5px; margin-right:5px; padding:5px; background-color: #fff;"
                          @click="underDecoration(item)"
                        >
                          <v-icon
                            color="yellow darken-2"
                            style="font-size:20px;"
                            >mdi-format-underline</v-icon
                          >マーカー
                        </span>
                      </v-col>
                    </v-row>

                    <v-row class="pa-1 ml-1" style="width:100%">
                      <v-col>
                        <v-text-field
                          label="おすすめポイント1"
                          hide-details="auto"
                          class="pa-0"
                          v-model="target_point1"
                          ref="textarea2"
                          id="2"
                          @blur="onBlur"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="pa-1 ml-1" style="width:100%">
                      <v-col>
                        <v-text-field
                          label="おすすめポイント2"
                          hide-details="auto"
                          class="pa-0"
                          v-model="target_point2"
                          ref="textarea3"
                          id="3"
                          @blur="onBlur"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="pa-1 ml-1" style="width:100%">
                      <v-col>
                        <v-text-field
                          label="おすすめポイント3"
                          hide-details="auto"
                          class="pa-0"
                          v-model="target_point3"
                          ref="textarea4"
                          id="4"
                          @blur="onBlur"
                        ></v-text-field>
                      </v-col>
                    </v-row></div
                ></v-tab-item>

                <!-- ユーザの声 -->
                <v-tab-item>
                  <div>
                    <v-row style="padding-right: 10px;">
                      <v-col
                        style="text-align:center;line-height: 2.5; text-align: left; margin-left: 40px;"
                      >
                        <span
                          style=" border: 1px solid #222; border-radius: 5px; margin-right:5px; padding:5px; background-color: #fff;"
                          @click="boldDecoration(item)"
                        >
                          <v-icon color="red accent-4" style="font-size:20px;"
                            >mdi-format-bold</v-icon
                          >赤太字
                        </span>
                        <span
                          style=" border: 1px solid #222; border-radius: 5px; margin-right:5px; padding:5px; background-color: #fff;"
                          @click="underDecoration(item)"
                        >
                          <v-icon
                            color="yellow darken-2"
                            style="font-size:20px;"
                            >mdi-format-underline</v-icon
                          >マーカー
                        </span>
                      </v-col>
                    </v-row>
                    <v-row class="pa-1 ml-1" style="width:100%">
                      <v-col>
                        <v-text-field
                          label="ユーザーの評価1"
                          hide-details="auto"
                          class="pa-0"
                          :rules="rules"
                          v-model="target_comment_rank1"
                          maxlength="3"
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          label="ユーザーの声1_タイトル"
                          hide-details="auto"
                          class="pa-0"
                          v-model="target_comment_title1"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="pa-1 ml-1" style="width:100%">
                      <v-col>
                        <v-textarea
                          label="ユーザーの声1"
                          hide-details="auto"
                          class="pa-1"
                          v-model="target_comment1"
                          ref="textarea5"
                          id="5"
                          rows="2"
                          @blur="onBlur"
                        ></v-textarea>
                      </v-col>
                    </v-row>

                    <v-row style="padding-right: 10px;">
                      <v-col
                        style="text-align:center;line-height: 2.5; text-align: left; margin-left: 40px;"
                      >
                        <span
                          style=" border: 1px solid #222; border-radius: 5px; margin-right:5px; padding:5px; background-color: #fff;"
                          @click="boldDecoration(item)"
                        >
                          <v-icon color="red accent-4" style="font-size:20px;"
                            >mdi-format-bold</v-icon
                          >赤太字
                        </span>
                        <span
                          style=" border: 1px solid #222; border-radius: 5px; margin-right:5px; padding:5px; background-color: #fff;"
                          @click="underDecoration(item)"
                        >
                          <v-icon
                            color="yellow darken-2"
                            style="font-size:20px;"
                            >mdi-format-underline</v-icon
                          >マーカー
                        </span>
                      </v-col>
                    </v-row>
                    <v-row class="pa-1 ml-1" style="width:100%">
                      <v-col>
                        <v-text-field
                          label="ユーザーの評価2"
                          hide-details="auto"
                          class="pa-0"
                          :rules="rules"
                          v-model="target_comment_rank2"
                          maxlength="3"
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          label="ユーザーの声2_タイトル"
                          hide-details="auto"
                          class="pa-0"
                          v-model="target_comment_title2"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="pa-1 ml-1" style="width:100%">
                      <v-col>
                        <v-textarea
                          label="ユーザーの声2"
                          hide-details="auto"
                          class="pa-1"
                          v-model="target_comment2"
                          ref="textarea6"
                          id="6"
                          rows="2"
                          @blur="onBlur"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>

                <!-- フッター -->
                <v-tab-item>
                  <v-row class="pa-1 mt-6" style="width:100%" align="center">
                    <v-col class="pa-0" width="15%" align="center">
                      <div class="img_preview">
                        <img
                          v-if="target_dl_img"
                          :src="target_dl_img"
                          width="150px"
                        />
                      </div>
                    </v-col>
                    <v-col cols="12" sm="10" md="10" class="pa-0" width="85%">
                      <v-form ref="form">
                        <v-file-input
                          v-model="input_image3"
                          counter
                          accept="image/*"
                          show-size
                          label="DLボタン上部の画像"
                          prepend-icon="mdi-image"
                          outlined
                          multiple
                          @change="onImagePicked3"
                        ></v-file-input>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row class="pa-1 ml-1" style="width:100%">
                    <v-col>
                      <v-text-field
                        label="DLボタン文字"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_dl_comment"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="pa-1 ml-1" style="width:100%">
                    <v-col>
                      <v-text-field
                        label="ダウンロードリンク"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_dl_url"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="pa-1 ml-1" style="width:100%">
                    <v-col>
                      <v-select
                        label="表示/非表示"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_disp_flg"
                        :items="disp_flg"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <!-- <v-row class="pa-1 ml-1" style="width:100%">
                <v-col>
                  <v-text-field
                    label="備考(メモなど)"
                    hide-details="auto"
                    class="pa-0"
                    v-model="target_remarks"
                  ></v-text-field>
                </v-col>
              </v-row>-->
                  <v-row class="pa-1 ml-1" style="width:100%;">
                    <v-col>
                      <v-textarea
                        row="2"
                        class="custom_textarea"
                        auto-grow
                        outlined
                        v-model="target_remarks"
                        label="備考(メモなど)"
                        counter="3000"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-1 ml-1">
            <v-btn color="blue darken-1" text @click="closeDialog()"
              >閉じる</v-btn
            >
            <v-row dense class="pa-1 ml-1" align="center" style>
              <v-col style="max-width:120px;text-align:right;">
                <v-btn color="blue" dark @click="saveItem()">更新</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script src="https://cdn.jsdelivr.net/npm/sortablejs@1.8.4/Sortable.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/Vue.Draggable/2.23.2/vuedraggable.umd.min.js"></script>

<script>
// Ajax通信ライブラリ
import axios from "axios";

const draggable = require("vuedraggable");

export default {
  components: {
    draggable: draggable,
  },

  //===========================
  // dataは基本的に変数の定義とかやるやつっぽい
  //===========================
  data() {
    return {
      tab: null,
      outline_tab: "0",

      img_target: "", //メディアターゲット(アプリ名で検索)

      genres: [
        "RPG",
        "シミュレーション",
        "MMO",
        "アクション",
        "シューティング",
        "MOBA",
        "スポーツ",
        "カード",
        "パズル",
        "リズム",
        "女性向け",
      ],
      tags: ["リセマラ"],
      //検索用パラメータ
      site_url: "",
      search: "新作アプリ",
      selectedKey: "",
      selectedItem: "",

      loading: false,

      height: 0,
      dialog: false,


      headers: [
        {
          text: "編集",
          align: "center",
          value: "edit",
          sortable: false,
          width: "5%",
        },
        {
          text: "順番",
          value: "rank",
          width: "5%",
          align: "center",
        },
        {
          text: "評価",
          value: "hyouka",
          width: "5%",
          align: "center",
        },
        {
          text: "PR",
          value: "pr",
          width: "5%",
          align: "center",
        },
        {
          text: "アイコン",
          value: "content",
          width: "5%",
          align: "center",
        },
        {
          text: "ID",
          align: "center",
          value: "id",
          width: "5%",
        },
        {
          text: "タイトル",
          value: "title",
          width: "20%",
          align: "left",
        },
        {
          text: "見出し",
          value: "description1",
          width: "20%",
          align: "center",
        },
        {
          text: "カテゴリ",
          value: "category",
          width: "15%",
          align: "center",
        },
        {
          text: "備考",
          value: "remarks",
          width: "20%",
          align: "center",
        },

        {
          text: "削除",
          align: "center",
          value: "delete",
          sortable: false,
          width: "15%",
        },
      ],

      list: [],
      editedIndex: -1,
      // editedItem: {
      //   id: "",
      //   category: "",
      //   title: "",
      //   source: "",
      //   memo: "",
      //   img_count: 0,
      //   imageData1: "",
      //   imageData2: ""
      // },

      showDialog: false,
      showDialogPreview: false,

      //画像拡大用
      imgDialog: false,

      // 入力必須の制約
      // required: value => !!value || "必須項目",
      rules: [(value) => !!value || "入力必須"],

      // 入力項目
      disp_flg: ["表示", "非表示"],
      category: ["新作アプリ", "今はじめどき", "人気アプリ"],

      target_id: "",
      target_store_id: "",
      target_title: "",
      target_rank: "",
      target_hyouka: "",
      target_genre: [],
      target_tag: "",
      target_publisher: "",
      target_pr: "",
      target_description1: "",
      target_url: "",
      target_description2: "",
      target_description3: "",
      target_point1: "",
      target_point2: "",
      target_point3: "",
      target_comment_title1: "",
      target_comment1: "",
      target_comment_rank1: "",
      target_comment_title2: "",
      target_comment2: "",
      target_comment_rank2: "",
      target_dl_comment: "",
      target_os: "",
      target_date: "",
      target_dl_vol: "",
      target_icon: "",
      target_category: "",
      target_dl_url: "",
      target_disp_flg: "",
      target_remarks: "",
      target_dl_img: "",
      input_image: [],
      input_image2: [],
      input_image3: [],
      article_img: "",
      img_items: [],
      img_file: null,
      focus_txt: "",
      focus_txt_ref: "",
    };
  },

  watch: {

  },

  //===========================
  // dom生成直前
  //===========================
  created: function() {
    this.dataSearch();
    // this.imgListDisp();
  },

  //===========================
  // dom作成直後
  //===========================
  mounted() {
    this.imgListDisp();
  },

  computed: {},

  //===========================
  // メソッド定義
  //===========================
  methods: {
    //ビデオ再生
    videoplay: function(html) {
      html = html.replace("data-src", "src");
      html = html.replace("muted", " muted autoplay");

      return html;
    },

    //フィルター
    customFilter: function(items, search, filter) {
      if (search == "非表示" && filter.disp_flg == 1) {
        return true;
      }
      if (filter.category == search && filter.disp_flg == 0) {
        return true;
      }

      if (filter.title.indexOf(search) !== -1) {
        return true;
      }

      return false;

      var self = this;
      return this.list.filter((i) => {
        return false;
      });
      // return this.list;

      // // if(value == this.search){
      // //   return true
      // // }
      // // return items.filter(item => props.some(prop => filter(getObjectValueByPath(item, prop), search)))

      // // this.list = [];
      // return;
    },

    //---------------------------
    // データ取得
    //---------------------------
    dataSearch: function() {
      this.loading = true;
      axios
        .get(process.env.VUE_APP_RECOMMEND_APPLI_LIST)
        .then((response) => {
          // v-data-tableを使うときは配列に格納する
          const items = [];
          const values = Object.values(response.data);

          // console.log(response.data);

          values.forEach((value) => {
            const item = this.itemPush(value);
            items.push(item);
          });
          this.list = items;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //---------------------------
    // 受け取った投稿データを配列に追加
    //---------------------------
    itemPush: function(value) {
      var genre = value.genre.split(",");
      // var tag = value.tag != null ? value.tag.split(',') : [];

      var item = {
        id: value.id,
        store_id: value.store_id,
        title: value.title,
        rank: value.rank,
        hyouka: value.hyouka,
        genre: genre,
        tag: value.tag,
        publisher: value.publisher,
        pr: value.pr,
        description1: value.description1,
        url: value.url,
        description2: value.description2,
        description3: value.description3,
        point1: value.point1,
        point2: value.point2,
        point3: value.point3,
        comment_title1: value.comment_title1,
        comment1: value.comment1,
        comment_rank1: value.comment_rank1,
        comment_title2: value.comment_title2,
        comment2: value.comment2,
        comment_rank2: value.comment_rank2,
        dl_img: value.dl_img,
        dl_comment: value.dl_comment,
        os: value.os,
        date: value.date,
        dl_vol: value.dl_vol,
        icon: value.icon,
        category: value.category,
        dl_url: value.dl_url,
        remarks: value.remarks,
        disp_flg: value.disp_flg,
        // showDialog: false,
      };
      return item;
    },

    //---------------------------
    // 編集画面開いたとき
    //---------------------------
    editItem(item) {
      this.tab = 0;
      this.outline_tab = 0;
      if ((item === void 0) === false) {
        this.target_id = item.id;
        this.target_store_id = item.store_id;
        this.target_title = item.title;
        this.target_rank = item.rank;
        this.target_hyouka = item.hyouka;
        this.target_genre = item.genre;
        this.target_tag = item.tag;
        this.target_publisher = item.publisher;
        this.target_pr = item.pr;
        this.target_description1 = item.description1;
        this.target_url = item.url;
        this.target_description2 = item.description2;
        this.target_description3 = item.description3;
        this.target_point1 = item.point1;
        this.target_point2 = item.point2;
        this.target_point3 = item.point3;
        this.target_comment_title1 = item.comment_title1;
        this.target_comment1 = item.comment1;
        this.target_comment_rank1 = item.comment_rank1;
        this.target_comment_title2 = item.comment_title2;
        this.target_comment2 = item.comment2;
        this.target_comment_rank2 = item.comment_rank2;
        this.target_dl_img = item.dl_img;
        this.target_dl_comment = item.dl_comment;
        this.target_os = item.os;
        this.target_date = item.date;
        this.target_dl_vol = item.dl_vol;
        this.target_icon = item.icon;
        this.target_category = item.category;
        this.target_dl_url = item.dl_url;
        this.target_remarks = item.remarks;

        if (item.disp_flg == 0) {
          this.target_disp_flg = "表示";
        } else {
          this.target_disp_flg = "非表示";
        }

        this.new_create_flg = false;
      } else {
        this.target_id = "";
        this.target_store_id = "";
        this.target_title = "";
        this.target_rank = "";
        this.target_hyouka = 5;
        this.target_genre = [];
        this.target_tag = "";
        this.target_publisher = "";
        this.target_pr = "";

        this.target_description1 = "";
        this.target_url = "";
        this.target_description2 = "";
        this.target_description3 = "";
        this.target_point1 = "";
        this.target_point2 = "";
        this.target_point3 = "";
        this.target_comment_title1 = "";
        this.target_comment1 = "";
        this.target_comment_rank1 = "";
        this.target_comment_title2 = "";
        this.target_comment2 = "";
        this.target_comment_rank2 = "";
        this.target_dl_img = "";
        this.target_dl_comment = "";
        this.target_os = "";
        this.target_date = "";
        this.target_dl_vol = "";
        this.target_icon = "";
        this.target_category = "今はじめどき";
        this.target_dl_url = "";
        this.target_remarks = "";
        this.target_disp_flg = "非表示";

        // this.new_create_flg = true;
      }

      this.showDialog = true;
      this.img_target = item.title;
      this.imgListDisp();
    },

    //---------------------------
    // 記事中画像差し込み
    //---------------------------
    insertImg(item) {
      this.focus_txt_ref.focus();

      if (item.img_path.indexOf("mp4") > -1) {
        document.execCommand(
          "insertText",
          false,
          "<video playsinline muted loop data-src='" +
            item.img_path +
            "' width='100%'></video>"
        );
      } else {
        document.execCommand(
          "insertText",
          false,
          "<img class='alignnone size-full' src='" +
            item.img_path +
            "' alt='" +
            item.alt +
            "' width='100%' loading='lazy' data-lity='labelon'>"
        );
      }
    },

    //---------------------------
    // p挿入
    //---------------------------
    pDecoration(item) {
      // const textarea = this.$refs.textarea.$refs.input;
      // // const selectedTxt = window.getSelection().toString();
      // console.log(this.focus_txt);
      this.focus_txt_ref.focus();
      document.execCommand(
        "insertText",
        false,
        "<p>" + this.focus_txt + "</p>"
      );
    },

    //---------------------------
    // リンク挿入
    //---------------------------
    linkDecoration(item) {
      // const textarea = this.$refs.textarea.$refs.input;
      // // const selectedTxt = window.getSelection().toString();
      // console.log(this.focus_txt);
      this.focus_txt_ref.focus();
      document.execCommand(
        "insertText",
        false,
        "<a href='◆◆◆◆◆'>" + this.focus_txt + "</a>"
      );
    },

    //---------------------------
    // 文字装飾_タイトル文字
    //---------------------------
    titleDecoration(item) {
      // const textarea = this.$refs.textarea.$refs.input;
      // // const selectedTxt = window.getSelection().toString();
      // console.log(this.focus_txt);
      this.focus_txt_ref.focus();
      document.execCommand(
        "insertText",
        false,
        "<h3>" + this.focus_txt + "</h3>"
      );
    },

    //---------------------------
    // 文字装飾_太字
    //---------------------------
    boldDecoration(item) {
      // const textarea = this.$refs.textarea.$refs.input;
      // // const selectedTxt = window.getSelection().toString();
      // console.log(this.focus_txt);
      this.focus_txt_ref.focus();
      document.execCommand(
        "insertText",
        false,
        "<span class='red bold'>" + this.focus_txt + "</span>"
      );
    },

    //---------------------------
    // 文字装飾_マーカー
    //---------------------------
    underDecoration(item) {
      // const textarea = this.$refs.textarea.$refs.input;
      // // const selectedTxt = window.getSelection().toString();
      // console.log(this.focus_txt);
      this.focus_txt_ref.focus();
      document.execCommand(
        "insertText",
        false,
        "<span class='marker'>" + this.focus_txt + "</span>"
      );
    },

    tableDecoration(item) {
      this.focus_txt_ref.focus();
      document.execCommand(
        "insertText",
        false,
        "<table class='border_none'><tr><td>ここに画像を挿入</td><td>ここに画像を挿入</td></tr></table>"
      );
    },

    onBlur: function(event) {
      const tmp = event.target.id;
      this.focus_txt_ref = this.$refs["textarea" + tmp].$refs.input;
      console.log(this.focus_txt_ref);
      this.focus_txt = window.getSelection().toString();
      console.log(this.focus_txt);
    },

    //---------------------------
    // 画像登録(アプリアイコン)
    //---------------------------
    onImagePicked(file) {
      // if (file == "") {
      //   return false;
      // }

      if (this.input_image == null || this.input_image == "") {
        this.target_icon = "";
        return false;
      }

      var img_size = file.length;
      if (img_size > 1) {
        alert("画像のアップロードは1ファイルまで");
        return;
      }

      if (file == null || file.length == 0) {
        return false;
      }

      this.target_icon = "";

      for (var i = 1; i <= img_size; ++i) {
        var tmp_file = file[i - 1];
        if (tmp_file !== undefined && tmp_file !== null) {
          if (tmp_file.name.lastIndexOf(".") <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(tmp_file);
          fr.addEventListener("load", () => {
            if (this.target_icon == "") {
              this.target_icon = fr.result;
              // this.editedItem.imageData1 = fr.result;
              // this.editedItem.img_count = 1;
            }
          });
        }
      }
    },

    //---------------------------
    // 画像アップロード(記事中画像)
    //---------------------------
    onImagePicked2(file) {
      // this.loading = true;

      if (this.input_image2 == null || this.input_image2 == "") {
        this.article_img = "";
        return false;
      }

      if (file == null || file.length == 0) {
        return false;
      }

      var img_item = "";

      var tmp_file = file[0];
      const fr = new FileReader();
      fr.readAsDataURL(tmp_file);
      fr.addEventListener("load", () => {
        if (this.article_img == "") {
          this.article_img = fr.result;
        }
      });

      // スリープ無しで実行するとarticle_imgに何も入らないので
      setTimeout(() => {
        // console.log(fr.result);
        axios
          .post(process.env.VUE_APP_RECOMMEND_APPLI_IMG_UPDATE, {
            img: this.article_img,
            alt: this.target_title,
          })

          .then(() => {
            alert("画像アップロード完了！");
            this.imgListDisp();
          })
          .catch((error) => {
            alert("エラー：\n" + error);
          })
          .finally(() => {
            // this.loading = false;
            this.$refs.img_file.value = null;
          });
      }, 500);

      // this.loading = false;
    },

    //---------------------------
    // 画像登録(DLバナー)
    //---------------------------
    onImagePicked3(file) {
      if (this.input_image3 == null || this.input_image3 == "") {
        this.target_dl_img = "";
        return false;
      }

      var img_size = file.length;
      if (img_size > 1) {
        alert("画像のアップロードは1ファイルまで");
        return;
      }

      if (file == null || file.length == 0) {
        return false;
      }

      this.target_dl_img = "";

      for (var i = 1; i <= img_size; ++i) {
        var tmp_file = file[i - 1];
        if (tmp_file !== undefined && tmp_file !== null) {
          if (tmp_file.name.lastIndexOf(".") <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(tmp_file);
          fr.addEventListener("load", () => {
            if (this.target_dl_img == "") {
              this.target_dl_img = fr.result;
              // this.editedItem.imageData1 = fr.result;
              // this.editedItem.img_count = 1;
            }
          });
        }
      }
    },

    //---------------------------
    // 画像一覧取得(記事中画像)
    //---------------------------
    imgListDisp: function() {
      var self = this;
      self.loading = true;
      axios
        .get(process.env.VUE_APP_RECOMMEND_APPLI_IMG_LIST, {
          params: { title: this.img_target },
        })
        .then((response) => {
          console.log(response);
          self.img_items = Object.values(response.data);
        })
        .finally(() => {
          self.loading = false;
        });
    },

    //---------------------------
    // 更新
    //---------------------------
    saveItem() {
      // if (this.target_num == "" || this.target_num == null) {
      //   alert("表示順を入力してください");
      //   return;
      // }

      // if (this.target_category == "" || this.target_category == null) {
      //   alert("カテゴリを入力してください");
      //   return;
      // }

      var msg = "";
      if (this.target_id.length == 0) {
        msg = "新規登録";
      } else {
        msg = "更新";
      }
      if (!window.confirm("データを" + msg + "します。よろしいですか？")) {
        return;
      }

      console.log(this.target_icon);

      this.loading = true;

      if (
        this.target_category == null ||
        this.target_category == "" ||
        this.target_category.length == 0
      ) {
        this.target_category = "今はじめどき";
      }

      if (this.target_disp_flg == "非表示") {
        this.target_rank = "";
        this.target_disp_flg = 1;
      }

      var item = {
        id: this.target_id,
        store_id: this.target_store_id,
        title: this.target_title,
        rank: this.target_rank,
        hyouka: this.target_hyouka,
        genre: this.target_genre.join(","),
        tag: this.target_tag,
        publisher: this.target_publisher,
        pr: this.target_pr,

        description1: this.target_description1,
        url: this.target_url,
        description2: this.target_description2,
        description3: this.target_description3,
        point1: this.target_point1,
        point2: this.target_point2,
        point3: this.target_point3,
        comment_title1: this.target_comment_title1,
        comment1: this.target_comment1,
        comment_rank1: this.target_comment_rank1,
        comment_title2: this.target_comment_title2,
        comment2: this.target_comment2,
        comment_rank2: this.target_comment_rank2,
        dl_img: this.target_dl_img,
        dl_comment: this.target_dl_comment,
        os: this.target_os,
        date: this.target_date,
        dl_vol: this.target_dl_vol,
        icon: this.target_icon,
        category: this.target_category,
        dl_url: this.target_dl_url,
        remarks: this.target_remarks,
        disp_flg: this.target_disp_flg,
      };
      console.log(item);

      axios
        .post(process.env.VUE_APP_RECOMMEND_APPLI_UPDATE, {
          data: item,
        })

        .then((response) => {
          console.log(response.data);
          alert("更新しました！");
          this.showDialog = false;
          this.dataSearch();
        })
        .catch((error) => {
          alert("テキストボックスに空か空白が設定されています\n" + error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //---------------------------
    // jsonファイル出力
    //---------------------------
    filePut() {
      if (!window.confirm("データを記事に反映します。よろしいですか？")) {
        return;
      }

      axios
        .get(process.env.VUE_APP_RECOMMEND_APPLI_FILE_PUT)

        .then(() => {
          // console.log(item);
          alert("更新しました！");
          this.showDialog = false;
          // this.dataSearch();
        })
        // .catch(error => {
        //   console.log(error);
        //   alert("予期せぬエラーが発生しました。\n" + error);
        // })
        .finally(() => {
          this.loading = false;
        });
    },

    //---------------------------
    // モーダル閉じる
    //---------------------------
    closeDialog() {
      var check1 = this.before_datas;
      var check2 = JSON.stringify(this.items);
      if (check1 != "[]" && check1 != check2) {
        if (
          !window.confirm(
            "変更が保存されていません。移動すると変更内容が失われます。"
          )
        ) {
          return true;
        }
      }

      this.showDialog = false;
    },

    enableItem(item) {
      var result = confirm("選択したデータを表示しますか？");
      if (result == false) {
        return;
      }
      item.rank = "";
      item.disp_flg = 0;
      var self = this;
      axios
        .post(process.env.VUE_APP_RECOMMEND_APPLI_UPDATE, {
          data: item,
        })
        .then(function(response) {
          console.log(response);
          self.close();
        });
    },

    //---------------------------
    // データ非表示
    //---------------------------
    disableItem(item) {
      var result = confirm("選択したデータを非表示にしますか？");
      if (result == false) {
        return;
      }

      item.rank = "";
      item.disp_flg = 1;

      console.log(item);

      var self = this;
      axios
        .post(process.env.VUE_APP_RECOMMEND_APPLI_UPDATE, {
          data: item,
        })
        .then(function(response) {
          console.log(response);
          self.close();
        });
    },

    //---------------------------
    // データ削除
    //---------------------------
    deleteItem(item) {
      var result = confirm("選択したデータを削除にしますか？");
      if (result == false) {
        return;
      }

      item.rank = "";
      item.disp_flg = 2;

      console.log(item);

      var self = this;
      axios
        .post(process.env.VUE_APP_RECOMMEND_APPLI_UPDATE, {
          data: item,
        })
        .then(function(response) {
          console.log(response);
          self.close();
        });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 100);
    },
  },
};
</script>

<style>
#preview .red {
  background-color: white !important;
  border-color: blue !important;
  color: red;
}

/* .v-application .red{
background-color: white !important;
    border-color: blue !important;
  color: red;
} */

.menu_icon span {
  display: inline;
}
.v-data-table th span {
  font-size: 12px !important;
}

.v-data-table table th {
  font-weight: normal;
  color: #888;
}

.v-data-table td,
.v-data-table th {
  padding: 2px;
  height: 30px !important;
}
.v-data-table tr:last-child td,
.v-data-table tr:last-child th {
  border: none;
}
table tr:nth-child(odd) td {
  background: #fbf9ff;
}
.main_table td,
.main_table th {
  background: transparent !important;
}

.main_table tr:last-child th,
.main_table tr:last-child td {
  border: none !important;
}

.marker {
  background: linear-gradient(transparent 75%, #ffe03b 80%) !important;
}
.v-window {
  height: 100vh;
}
.v-item--active label {
  color: #2196f3 !important;
  font-weight: bold;
}
.all_preview {
  font-size: 14px;
  line-height: 1.6;
}
.all_preview img,
.all_preview video {
  margin: 10px auto;
}
.pr {
  background: #ff5722;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 11px;
  color: white;
}
</style>
